import { currency, decimal, formatDate } from '@/shared/lib/format';
import { passbookCurrency, quantityLabel } from '@/shared/lib/passbook-utils';
import type { Lead, Passbook } from '@/shared/types';

function csvEscape(value: string | number): string {
  const s = String(value ?? '');
  if (s.includes('"') || s.includes(',') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/** CSV direto no navegador (sem passar pelo export por e-mail) — pensado pra seleção pontual de leads. */
export function exportLeadsCsv(
  leads: Lead[],
  passbook: Passbook,
  opts: { uniqueIdLabel: string; canSeeEmail: boolean },
): void {
  const labelQtde = quantityLabel(passbook);
  const currencyCode = passbookCurrency(passbook);
  const isCashback = Boolean(passbook.hasCashback);
  const balance = (lead: Lead) =>
    isCashback ? currency(lead.total_points ?? 0, currencyCode) : decimal(lead.total_points ?? 0);

  const header = [
    'Nome',
    opts.uniqueIdLabel,
    ...(opts.canSeeEmail ? ['E-mail'] : []),
    'Telefone',
    labelQtde,
    'Loja de cadastro',
    'Cadastro',
    'Última atualização',
    'Status',
  ];

  const rows = leads.map((lead) => [
    lead.profile?.name ?? '',
    lead.profile?.uniqueId ?? '',
    ...(opts.canSeeEmail ? [lead.email ?? ''] : []),
    lead.phone ?? '',
    balance(lead),
    lead.storeName ?? '',
    lead.createdAt ? formatDate(lead.createdAt) : '',
    lead.updated ? formatDate(lead.updated) : '',
    lead.status === 'blocked' ? 'Bloqueado' : 'Ativo',
  ]);

  const csv = [header, ...rows].map((row) => row.map(csvEscape).join(',')).join('\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `leads-${formatDate(new Date().toISOString()).replace(/\//g, '-')}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
